import {
	useLocation,
	useNavigate,
	useParams as useRouterParams,
	useSearchParams as useRouterSearchParams,
} from 'react-router-dom';

// Per fermare l'uscita da una pagina con modifiche non salvate.
export { useBlocker } from 'react-router-dom';

export function useRouter() {
	const navigate = useNavigate();
	return {
		// second arg mirrors Next's NavigateOptions ({ scroll }); ignored here.
		push: (href: string, _opts?: { scroll?: boolean }) => navigate(href),
		replace: (href: string, _opts?: { scroll?: boolean }) => navigate(href, { replace: true }),
		back: () => navigate(-1),
		forward: () => navigate(1),
		refresh: () => navigate(0),
		prefetch: () => {},
	};
}
export function usePathname(): string {
	return useLocation().pathname;
}
export function useSearchParams(): URLSearchParams {
	return useRouterSearchParams()[0];
}
export function useParams<T extends Record<string, string> = Record<string, string>>(): T {
	return useRouterParams() as T;
}
export function redirect(href: string): never {
	window.location.assign(href);
	throw new Error('redirect');
}
